var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-answers-button",class:{ disabled: _vm.isDisabled },on:{"click":_vm.downloadTaskAnswers}},[_vm._v(" "+_vm._s(_vm.$t('label.downloadAnswers'))+" "),_c('DownloadIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }